import i18n from './i18n';

export const translateEntryTypeName = (name: string, language?: string): string => {
  const currentLanguage = language || i18n.language;

  if (currentLanguage === 'pt-BR') {
    const translations: Record<string, string> = {
      'tithe': 'Dízimo',
      'Sabbath School': 'Escola Sabatina',
      'fund': 'Caixa',
      'expenses': 'Despesas'
    };

    return translations[name] || name;
  }

  return name;
};
